import type { AppError } from "@/Modules/App/Models/Domain/AppError";

import { hasValue, isObject } from "@/Utils/Objects";

export const isAppError = (value: unknown): value is AppError => {
  return (
    isObject(value) &&
    typeof value["message"] === "string" &&
    (!hasValue(value["i18nKey"]) || typeof value["i18nKey"] === "string")
  );
};
